<template>
  <div>
    <svg :viewBox="`0 0 ${size} ${size}`" @click="handleClick($event)" :width="size" :height="size">
      <circle :cx="center" :cy="center" :r="radius" fill="#f0f0f0" stroke="#000" stroke-width="2" />

      <!-- Sectores -->
      <path
        v-for="(sector, index) in sectors"
        :key="index"
        :d="sector.path"
        :fill="internalValue.includes(index + 1) ? selectedColor : unselectedColor"
        stroke="#000"
        stroke-width="1"
      />

      <!-- Etiquetas de sectores -->
      <text
        v-for="(sector, index) in sectors"
        :key="'text-' + index"
        :x="sector.textX"
        :y="sector.textY"
        text-anchor="middle"
        alignment-baseline="middle"
        font-size="16"
      >
        {{ labels[index] || index + 1 }}
      </text>

      <!-- Centro -->
      <circle
        :cx="center"
        :cy="center"
        :r="innerRadius"
        :fill="internalValue.includes(5) ? selectedColor : unselectedColor"
        stroke="#000"
        stroke-width="2"
      />
      <text :x="center" :y="center" text-anchor="middle" alignment-baseline="middle" font-size="16">
        {{ labels[4] || 5 }}
      </text>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'CircularPicker',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    size: {
      type: Number,
      default: 200
    },
    selectedColor: {
      type: String,
      default: '#8fc1e3'
    },
    unselectedColor: {
      type: String,
      default: '#ffffff'
    },
    labels: {
      type: Array,
      default: () => ['A', 'B', 'C', 'D', 'E'] // 4 sectores + centro
    }
  },
  data() {
    return {
      sectors: this.generateSectors()
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    center() {
      return this.size / 2;
    },
    radius() {
      return this.size / 2 - 10;
    },
    innerRadius() {
      return this.size / 6.5;
    }
  },
  methods: {
    generateSectors() {
      const sectors = [];
      const radius = this.size / 2 - 10;
      const center = this.size / 2;
      const angles = [0, 90, 180, 270, 360];

      for (let i = 0; i < 4; i++) {
        const startAngle = angles[i] * (Math.PI / 180);
        const endAngle = angles[i + 1] * (Math.PI / 180);
        const x1 = center + radius * Math.cos(startAngle);
        const y1 = center + radius * Math.sin(startAngle);
        const x2 = center + radius * Math.cos(endAngle);
        const y2 = center + radius * Math.sin(endAngle);
        const path = `M${center},${center} L${x1},${y1} A${radius},${radius} 0 0,1 ${x2},${y2} Z`;
        const textX = center + (radius * 0.6) * Math.cos((startAngle + endAngle) / 2);
        const textY = center + (radius * 0.6) * Math.sin((startAngle + endAngle) / 2);
        sectors.push({ path, textX, textY });
      }

      return sectors;
    },
    handleClick(event) {
      const svg = event.currentTarget;
      const pt = svg.createSVGPoint();
      pt.x = event.clientX;
      pt.y = event.clientY;

      const matrix = svg.getScreenCTM();
      if (!matrix) return;

      const cursorpt = pt.matrixTransform(matrix.inverse());
      const dx = cursorpt.x - this.center;
      const dy = cursorpt.y - this.center;
      const distance = Math.sqrt(dx * dx + dy * dy);

      if (distance <= this.innerRadius) {
        this.toggleSelection(5);
        return;
      }

      const angle = (Math.atan2(dy, dx) * 180 / Math.PI + 360) % 360;
      const selected = Math.floor(angle / 90) + 1;

      this.toggleSelection(selected);
    },
    toggleSelection(number) {
      const copy = [...this.internalValue];
      const idx = copy.indexOf(number);
      if (idx >= 0) {
        copy.splice(idx, 1);
      } else {
        copy.push(number);
      }
      this.internalValue = copy;
    }
  }
};
</script>
